<script>
	import { onDestroy, onMount } from 'svelte';
	import { Modals, closeModal, openModal, modals } from 'svelte-modals';
	import { app } from '$lib/stores/app/store';
	import LoadingModalContent from './LoadingModalContent.svelte';

	$: loading = $app?.global?.loading;

	/** @type {null | (() => void)} */
	let unsubscribeModals = null;

	/** @type {null | (() => void)} */
	let restoreScrollLock = null;

	/**
	 * Prevents the page behind modals from scrolling on mobile devices
	 * @returns {void}
	 */
	function lockPageScroll() {
		if (restoreScrollLock || typeof document === 'undefined') return;

		const { documentElement, body } = document;
		const scrollY = window.scrollY || documentElement.scrollTop || body.scrollTop || 0;
		const { overflow, overflowY } = documentElement.style;
		const { position, top, left, right, width } = body.style;

		documentElement.style.overflow = 'hidden';
		documentElement.style.overflowY = 'hidden';
		body.style.position = 'fixed';
		body.style.top = `-${scrollY}px`;
		body.style.left = '0';
		body.style.right = '0';
		body.style.width = '100%';

		restoreScrollLock = () => {
			documentElement.style.overflow = overflow;
			documentElement.style.overflowY = overflowY;
			body.style.position = position;
			body.style.top = top;
			body.style.left = left;
			body.style.right = right;
			body.style.width = width;
			window.scrollTo(0, scrollY);
			restoreScrollLock = null;
		};
	}

	/**
	 * @returns {void}
	 */
	function unlockPageScroll() {
		restoreScrollLock?.();
	}

	onMount(() => {
		unsubscribeModals = modals.subscribe((activeModals) => {
			if (activeModals.length > 0) {
				lockPageScroll();
				return;
			}

			unlockPageScroll();
		});
	});

	onDestroy(() => {
		unsubscribeModals?.();
		unlockPageScroll();
	});

	$: if (loading) {
		openModal(LoadingModalContent);
	} else {
		closeModal();
	}
</script>

<Modals>
	<div
		slot="backdrop"
		class="backdrop cursor-default"
		class:z-102={loading}
		role="button"
		aria-pressed="false"
		tabindex="0"
		on:click={() => window.dispatchEvent(new CustomEvent('global:backdrop-click'))}
		on:keydown={() => window.dispatchEvent(new CustomEvent('global:backdrop-click'))}
	/>
</Modals>
